import type { AllRouteEndpoints } from "../routeTypes";
export const generativeAiBrandGuidelinesCacheKeys: AllRouteEndpoints[] = [
  "/generative_ai/rate_limit_stats",
  "/generative_ai/list_brand_guidelines",
];
